export const getValueByKeyPath = (obj: object, keyPath: string): any => {
  const keys = keyPath.split('.'); // Разделяем строку ключей на массив
  return keys.reduce((acc, key) => {
    return acc && acc[key] !== undefined ? acc[key] : undefined;
  }, obj as any);
};
